const blockchainOptions = [
    {
        name: 'Transactions',
        value: 'txs'
    },
    {
        name: 'Pending Transactions',
        value: 'txsPending'
    },
    {
        name: 'Contract Internal Transactions',
        value: 'txsInternal'
    },
    { type: 'divider' },
    {
        name: 'Blocks',
        value: 'blocks'
    },
    { type: 'divider' },
    // {
    //     name: 'Top Accounts',
    //     value: 'accounts'
    // },
    {
        name: 'Verified Contracts',
        value: 'contractsVerified'
    }
]

module.exports = { blockchainOptions }
